/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelInvestigationDemandRequest } from '../models/CancelInvestigationDemandRequest';
import type { CreateExternalInvestigationResultRequest } from '../models/CreateExternalInvestigationResultRequest';
import type { CreateInvestigationDemandRequest } from '../models/CreateInvestigationDemandRequest';
import type { CreateInvestigationDemandResponse } from '../models/CreateInvestigationDemandResponse';
import type { CreateInvestigationTestRequest } from '../models/CreateInvestigationTestRequest';
import type { CreateInvestigationTestResponse } from '../models/CreateInvestigationTestResponse';
import type { CreateInvestigationTestResultRequest } from '../models/CreateInvestigationTestResultRequest';
import type { CreateLaboratoryTestResultRequest } from '../models/CreateLaboratoryTestResultRequest';
import type { CreateOrUpdateSupplyTemplateRequest } from '../models/CreateOrUpdateSupplyTemplateRequest';
import type { CreateScreeningInvestigationRequest } from '../models/CreateScreeningInvestigationRequest';
import type { CreateScreeningInvestigationResponse } from '../models/CreateScreeningInvestigationResponse';
import type { CreateSpecimenInvestigationRequest } from '../models/CreateSpecimenInvestigationRequest';
import type { CreateSpecimenInvestigationResponse } from '../models/CreateSpecimenInvestigationResponse';
import type { GetListSpecimensResponse } from '../models/GetListSpecimensResponse';
import type { GetTbCaseStatusResponse } from '../models/GetTbCaseStatusResponse';
import type { GetTbScreeningListResponse } from '../models/GetTbScreeningListResponse';
import type { HarvestSpecimenRequest } from '../models/HarvestSpecimenRequest';
import type { InvestigationDemandEnrichedDto } from '../models/InvestigationDemandEnrichedDto';
import type { InvestigationDemandListDto } from '../models/InvestigationDemandListDto';
import type { InvestigationDemandSortBy } from '../models/InvestigationDemandSortBy';
import type { InvestigationDemandStatus } from '../models/InvestigationDemandStatus';
import type { InvestigationTestEnrichedDto } from '../models/InvestigationTestEnrichedDto';
import type { InvestigationTestsListDto } from '../models/InvestigationTestsListDto';
import type { InvestigationTestSortBy } from '../models/InvestigationTestSortBy';
import type { InvestigationTestStatus } from '../models/InvestigationTestStatus';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { MonthlyInvestigationResultStatisticsDto } from '../models/MonthlyInvestigationResultStatisticsDto';
import type { RejectInvestigationTestRequest } from '../models/RejectInvestigationTestRequest';
import type { RejectSpecimenRequest } from '../models/RejectSpecimenRequest';
import type { SearchSpecimenInvestigationsQueryResponse } from '../models/SearchSpecimenInvestigationsQueryResponse';
import type { SearchSpecimenSortBy } from '../models/SearchSpecimenSortBy';
import type { SpecimenDto } from '../models/SpecimenDto';
import type { SpecimenLaboratoryStatus } from '../models/SpecimenLaboratoryStatus';
import type { SpecimenReceptionRequest } from '../models/SpecimenReceptionRequest';
import type { SpecimenStatus } from '../models/SpecimenStatus';
import type { SupplyTemplateListDto } from '../models/SupplyTemplateListDto';
import type { TransferSpecimenRequest } from '../models/TransferSpecimenRequest';
import type { TransferSpecimenResponse } from '../models/TransferSpecimenResponse';
import type { TransmitTbCaseResponse } from '../models/TransmitTbCaseResponse';
import type { UpdateExternalInvestigationResultRequest } from '../models/UpdateExternalInvestigationResultRequest';
import type { UpdateInvestigationDemandRequest } from '../models/UpdateInvestigationDemandRequest';
import type { UpdateInvestigationTestRequest } from '../models/UpdateInvestigationTestRequest';
import type { UpdateInvestigationTestResultRequest } from '../models/UpdateInvestigationTestResultRequest';
import type { UpdateSpecimenRequest } from '../models/UpdateSpecimenRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvestigationsService {
    /**
     * Update the investigation test.
     * Update the investigation test based on the provided identifier.
     * @param id The unique identifier of the investigation test to be updated.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateInvestigationTestEndpoint(
        id: string,
        requestBody: UpdateInvestigationTestRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/tests/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test has not been found.`,
            },
        });
    }
    /**
     * Get investigation test information.
     * Get investigation test based on the provided identifier.
     * @param id The unique identifier of the investigation test.
     * @returns InvestigationTestEnrichedDto The investigation test information.
     * @throws ApiError
     */
    public static getInvestigationTestEndpoint(
        id: string,
    ): CancelablePromise<InvestigationTestEnrichedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/tests/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test has not been found.`,
            },
        });
    }
    /**
     * Delete the investigation test.
     * Delete the investigation test based on the provided identifier.
     * @param id The unique identifier of the investigation test to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteInvestigationTestEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/investigation-demands/tests/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test has not been found.`,
            },
        });
    }
    /**
     * Submits an investigation test to validation
     * This endpoint requires the following permissions: [ Investigations.Tests.SubmitToValidation ]
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static submitInvestigationTestToValidationEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/tests/{id}/submit-to-validation',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get cohort monthly investigation result statistics.
     * Returns, per month, each investigation test type that has results, with the total number of results split by result variant (Pozitiv / Negativ / Indeterminat / ...). Cohort-wide across all patients by default; the optional DateFrom/DateTo filter the result date and the optional PersonId narrows the statistics to a single patient.
     * @param dateFrom Optional inclusive lower bound applied to the result date.
     * @param dateTo Optional inclusive upper bound applied to the result date.
     * @param personId Optional patient (person) filter. When set, only the results of that
     * patient are counted; otherwise the statistics are cohort-wide.
     * @returns MonthlyInvestigationResultStatisticsDto The cohort monthly investigation result statistics.
     * @throws ApiError
     */
    public static getMonthlyResultStatisticsEndpoint(
        dateFrom?: string | null,
        dateTo?: string | null,
        personId?: string | null,
    ): CancelablePromise<MonthlyInvestigationResultStatisticsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-statistics/monthly-results',
            query: {
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'personId': personId,
            },
            errors: {
                400: `The provided date range is invalid.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Update an investigation test result of any source.
     * Updates the result values regardless of how the result was entered (manual, device or external laboratory). While the test is not yet approved (not yet sent to the requesting doctor) any laboratory user can edit; after approval the edit requires the [ EditApprovedResult ] permission. The person case status is recomputed with the new values.
     * @param id The identifier of the test result.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateInvestigationTestResultEndpoint(
        id: string,
        requestBody: UpdateInvestigationTestResultRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/tests/results/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The parameters are invalid or the result was already approved and the user lacks the permission to edit approved results.`,
                401: `User is not authorized.`,
                404: `The result has not been found.`,
            },
        });
    }
    /**
     * Creates results from sent from laboratory
     * This endpoint requires the following permissions: [  ]This endpoint processes and records the test results sent from laboratory equipment.
     *
     * **Workflow:**
     * 1. It retrieves and validates the received data to ensure that all necessary information.
     * 2. It searches the system for the corresponding investigation test based on the provided code. If the test is not found, the request is rejected.
     * 3. After the successful validation and identification of the test, a new result is created and permanently saved in the system.
     * 4. Finally, an internal event `LaboratoryTestResultCreated` is triggered. This event notifies other parts of the system that a new result is available.
     *
     * The caller will receive a confirmation as soon as the result is created, without having to wait for the background processes to complete.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createLaboratoryTestResultEndpoint(
        requestBody: CreateLaboratoryTestResultRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/laboratory/tests/results',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update an externally sourced investigation result.
     * Only results entered from an external laboratory can be updated. The person case status is recomputed with the new values.
     * @param id The identifier of the external result.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateExternalInvestigationResultEndpoint(
        id: string,
        requestBody: UpdateExternalInvestigationResultRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/tests/results/external/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or the result is not externally sourced.`,
                401: `User is not authorized.`,
                404: `The external result has not been found.`,
            },
        });
    }
    /**
     * @param id The identifier of the external result.
     * @returns any Success
     * @throws ApiError
     */
    public static deleteExternalInvestigationResultEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/investigation-demands/tests/results/external/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Register a result performed by an external laboratory into the patient file.
     * Creates the minimal investigation chain (demand, specimen, investigation, test) in the background and stores the result marked as externally sourced.
     * @param requestBody
     * @returns any The external result has been registered successfully.
     * @throws ApiError
     */
    public static createExternalInvestigationResultEndpoint(
        requestBody: CreateExternalInvestigationResultRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/tests/results/external',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The person, classifier element or media file has not been found.`,
            },
        });
    }
    /**
     * Create investigation test result.
     * Create investigation test result.
     * @param id The unique identifier of the test.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createInvestigationTestResultEndpoint(
        id: string,
        requestBody: CreateInvestigationTestResultRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/tests/{id}/results',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test has not been found.`,
            },
        });
    }
    /**
     * Rejects an investigation test
     * This endpoint requires the following permissions: [ Investigations.Tests.Reject ]
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectInvestigationTestEndpoint(
        id: string,
        requestBody: RejectInvestigationTestRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/tests/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get paginated list of investigation tests.
     * Get paginated list of investigation tests.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm This property is used to filter investigation tests
     * containing strings matching the specified value.
     * @param code This property represents the unique identifier or QR code
     * associated with an investigation test.
     * It is used for referencing a specific test within the system.
     * Use this to get tests only by specific test code.
     * @param sortBy Specifies the property by which the investigation tests should be sorted.
     * If null, no particular sorting is applied.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the investigation tests.
     * If null, the default sorting direction is applied.
     * @param investigationId Represents the unique identifier of an investigation demand.
     * Use this to get tests only for specific investigation demand.
     * @param specimenIds This property holds a set of unique identifiers for specimens
     * used to filter investigation tests based on their associated specimens.
     * If provided, the query will include only tests linked to the specified specimen IDs.
     * @param institutionId Represents the unique identifier of an institution associated with the investigation tests query.
     * Use this to filter tests based on the institution they belong to.
     * @param personId Represents the unique identifier of a person associated with the query.
     * Use this to filter investigation tests specific to a person.
     * @param typeId Represents the unique identifier of a test type.
     * Use this to filter investigation tests by specific test type.
     * @param status Represents the current status of an investigation test.
     * Use this property to filter or track investigation tests
     * based on their progression.
     * @param testedAtFrom Gets or sets the start date for filtering tests based on when they were performed.
     * Use this property to filter tests performed on or after the specified date.
     * @param testedAtTo Gets or sets the end date for filtering tests based on when they were performed.
     * Use this property to filter tests performed on or before the specified date.
     * @returns InvestigationTestsListDto The paginated list of investigation tests.
     * @throws ApiError
     */
    public static getInvestigationTestsEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        code?: string | null,
        sortBy?: InvestigationTestSortBy | null,
        sortDirection?: ListSortDirection | null,
        investigationId?: string | null,
        specimenIds?: Array<string> | null,
        institutionId?: string | null,
        personId?: string | null,
        typeId?: string | null,
        status?: InvestigationTestStatus | null,
        testedAtFrom?: string | null,
        testedAtTo?: string | null,
    ): CancelablePromise<InvestigationTestsListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/tests',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'code': code,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'investigationId': investigationId,
                'specimenIds': specimenIds,
                'institutionId': institutionId,
                'personId': personId,
                'typeId': typeId,
                'status': status,
                'testedAtFrom': testedAtFrom,
                'testedAtTo': testedAtTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Create investigation test.
     * Create investigation test.
     * @param requestBody
     * @returns CreateInvestigationTestResponse The investigation test.
     * @throws ApiError
     */
    public static createInvestigationTestEndpoint(
        requestBody: CreateInvestigationTestRequest,
    ): CancelablePromise<CreateInvestigationTestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/tests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation has not been found.`,
            },
        });
    }
    /**
     * Approve the investigation test.
     * Approve the investigation test.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static approveInvestigationTestEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/tests/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test does not exist or is already approved.`,
            },
        });
    }
    /**
     * Get a test type supply template.
     * Get a test type supply template.
     * @param typeId Represents the unique identifier of a type.
     * Use this to filter investigation tests by a specific type.
     * @returns SupplyTemplateListDto The list of type supply template.
     * @throws ApiError
     */
    public static getSupplyTemplateListEndpoint(
        typeId: string,
    ): CancelablePromise<SupplyTemplateListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/tests/supplies/templates/{typeId}',
            path: {
                'typeId': typeId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Delete an investigation supply template.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteSupplyTemplateEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/investigation-demands/tests/supplies/templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The supply template has not been found.`,
            },
        });
    }
    /**
     * Create or update an investigation supply template based on the provided test type identifier.
     * @param testTypeId The unique identifier of the investigation type for supplies to be updated.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createOrUpdateSupplyTemplateEndpoint(
        testTypeId: string,
        requestBody: CreateOrUpdateSupplyTemplateRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/tests/supplies/templates/{testTypeId}',
            path: {
                'testTypeId': testTypeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation test type has not been found.`,
            },
        });
    }
    /**
     * Update a specimen laboratory life cycle status
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the unique identifier for the specimen being updated.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateSpecimenEndpoint(
        id: string,
        requestBody: UpdateSpecimenRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/specimens/{id}/laboratory',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Transfer a specimen to another laboratory.
     * This endpoint requires the following permissions: [  ]
     *
     * Actually, this creates a new specimen based on the original specimen but with a new code.
     * New specimen is created in the destination laboratory with the Harvested status.
     * @param id Gets or initializes the unique identifier for the specimen.
     * @param requestBody
     * @returns TransferSpecimenResponse Success
     * @throws ApiError
     */
    public static transferSpecimenEndpoint(
        id: string,
        requestBody: TransferSpecimenRequest,
    ): CancelablePromise<TransferSpecimenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/specimens/{id}/transfer',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Reject a specimen
     * This endpoint requires the following permissions: [ Investigations.Specimens.Reject ] Acest endpoint permite personalului de laborator să respingă o probă care nu poate fi procesată. Documentează motivul respingerii și actualizează starea probei. Procesul de respingere este o măsură critică de control al calității care asigură că doar probele valide continuă pentru analiză.
     * @param id Gets the unique identifier of a specimen to be rejected.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectSpecimenEndpoint(
        id: string,
        requestBody: RejectSpecimenRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/specimens/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Mark a specimen as received.
     * This endpoint requires the following permissions: [  ]
     * @param id The unique identifier of the specimen to be harvested.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static specimenReceptionEndpoint(
        id: string,
        requestBody: SpecimenReceptionRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/specimens/{id}/reception',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtain a list of specimen investigations.
     * This endpoint requires the following permissions: [  ]
     * @param institutionIds Gets or initializes a set of institution IDs to filter investigations by.
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param specimenIds Gets or initializes the unique identifier for the specimen.
     * @param typeIds Gets or sets the collection of investigation type identifiers
     * used to filter the specimen investigations.
     * @param code Gets or initializes the investigation code for filtering.
     * @param createdAtFrom Gets or initializes the start date to filter investigations created after this date.
     * @param createdAtTo Gets or initializes the end date to filter investigations created before this date.
     * @returns SearchSpecimenInvestigationsQueryResponse Success
     * @throws ApiError
     */
    public static getListSpecimenInvestigationsEndpoint(
        institutionIds: Array<string>,
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        specimenIds?: Array<string> | null,
        typeIds?: Array<string> | null,
        code?: string | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
    ): CancelablePromise<SearchSpecimenInvestigationsQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/specimens/investigations',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'specimenIds': specimenIds,
                'typeIds': typeIds,
                'code': code,
                'institutionIds': institutionIds,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Create a new specimen investigation.
     * This endpoint requires the following permissions: [  ]
     * @param specimenId Gets or initializes the unique identifier for the specimen.
     * @param requestBody
     * @returns CreateSpecimenInvestigationResponse Success
     * @throws ApiError
     */
    public static createSpecimenInvestigationEndpoint(
        specimenId: string,
        requestBody: CreateSpecimenInvestigationRequest,
    ): CancelablePromise<CreateSpecimenInvestigationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/specimens/{specimenId}/investigations',
            path: {
                'specimenId': specimenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Harvest the specimen.
     * This endpoint requires the following permissions: [ Investigations.Specimens.Harvest ]Acest endpoint este utilizat pentru a înregistra procesul de recoltare a unei probe. Capturează momentul și persoana care a recoltat proba, împreună cu orice materialeutilizate în timpul procesului de recoltare. Recoltarea reprezintă colectarea inițială a unei probe biologice de la o sursă.
     * @param id The unique identifier of the specimen to be harvested.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static harvestSpecimenEndpoint(
        id: string,
        requestBody: HarvestSpecimenRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/specimens/{id}/harvest',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtain a paginated list of specimens.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets the page number. Defaults to 1.
     * @param pageSize Gets the optional page size.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * Defaults to Descending.
     * @param sortBy Specifies the property by which the items should be sorted.
     * Defaults to Code.
     * @param ids Gets or sets the collection of unique identifiers (IDs) for filtering the query.
     * Defaults to an empty set.
     * @param code Gets or sets the unique identifier associated with the specimen.
     * Use this property to retrieve specimens matching the specified code.
     * @param laboratoryInternalCode Gets the internal code of the laboratory representing the specimen.
     * This property is optional and can be used for filtering or referencing specific specimens.
     * @param demandInstitutionIds Gets the collection of GUIDs representing the demand institutions
     * for filtering specimens. Optional.
     * @param institutionIds Gets or sets the set of institution identifiers to be used for filtering specimens.
     * Allows narrowing down the query to specimens associated with specific institutions.
     * @param demandIds Gets the set of unique demand identifiers to filter specimens.
     * @param typeIds Gets or sets the collection of TypeIds to filter the specimen search results.
     * This property is optional.
     * If specified, only specimens associated with the given
     * TypeIds will be included in the response.
     * @param personIds Gets the collection of unique identifiers representing
     * persons associated with the specimens.
     * @param status Gets the collection of specimen statuses to filter by.
     * Each status corresponds to a stage in the specimen's lifecycle,
     * such as Created, Harvested, InProgress, Canceled, or Completed.
     * This property is optional and can include multiple statuses.
     * @param laboratoryStatus Gets the set of specimen laboratory statuses used to filter results.
     * Represents statuses such as received, inconform, sent to validation, validated, or rejected.
     * @param createdAtFrom Gets or sets the minimum date and time for filtering
     * specimens based on their creation date.
     * This property is used to retrieve specimens
     * that were created on or after the specified date and time.
     * @param createdAtTo Gets or sets the upper boundary for the creation date of the specimens to be retrieved.
     * Use this to filter specimens created on or before a specific date.
     * @param isPregnancyMonitoring Indicates whether to filter investigation demands specifically for pregnancy monitoring.
     * If set to true, only investigation demands related to pregnancy monitoring will be returned.
     * If set to false, investigation demands not related to pregnancy monitoring will be returned.
     * If null, this filter is not applied.
     * @param isNewborn Indicates whether the investigation demand is related to a newborn individual.
     * Optional property that may be used to filter investigation demands specific to newborns.
     * @param isScreening Filters by the screening flag of the specimen's demand: true returns only screening specimens,
     * false only the non-screening ones, null (default) does not filter.
     * @returns GetListSpecimensResponse Success
     * @throws ApiError
     */
    public static getListSpecimensEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: SearchSpecimenSortBy | null,
        ids?: Array<string> | null,
        code?: string | null,
        laboratoryInternalCode?: string | null,
        demandInstitutionIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        demandIds?: Array<string> | null,
        typeIds?: Array<string> | null,
        personIds?: Array<string> | null,
        status?: Array<SpecimenStatus> | null,
        laboratoryStatus?: Array<SpecimenLaboratoryStatus> | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        isPregnancyMonitoring?: boolean | null,
        isNewborn?: boolean | null,
        isScreening?: boolean | null,
    ): CancelablePromise<GetListSpecimensResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/specimens/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'ids': ids,
                'code': code,
                'laboratoryInternalCode': laboratoryInternalCode,
                'demandInstitutionIds': demandInstitutionIds,
                'institutionIds': institutionIds,
                'demandIds': demandIds,
                'typeIds': typeIds,
                'personIds': personIds,
                'status': status,
                'laboratoryStatus': laboratoryStatus,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'isPregnancyMonitoring': isPregnancyMonitoring,
                'isNewborn': isNewborn,
                'isScreening': isScreening,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get a specimen by identifier
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the specimen identifier.
     * @returns SpecimenDto Success
     * @throws ApiError
     */
    public static getSpecimenEndpoint(
        id: string,
    ): CancelablePromise<SpecimenDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/specimens/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Manually transmits a person to the external TB system. Replaces the previous automatic
     * transmission: the HIV doctor now decides when to send. Idempotent — a person already
     * transmitted is not sent again. After a new transmission the assigned HIV doctor is notified.
     * @param personId Id of the person to transmit (bound from the route).
     * @returns TransmitTbCaseResponse Success
     * @throws ApiError
     */
    public static transmitTbCaseEndpoint(
        personId: string,
    ): CancelablePromise<TransmitTbCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/screening/tb/{personId}/transmit',
            path: {
                'personId': personId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param personId
     * @returns GetTbCaseStatusResponse Success
     * @throws ApiError
     */
    public static getTbCaseStatusEndpoint(
        personId: string,
    ): CancelablePromise<GetTbCaseStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/screening/tb/{personId}/status',
            path: {
                'personId': personId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param pageNumber Page number to retrieve. Defaults to 1.
     * @param pageSize Number of items per page. Defaults to 10.
     * @returns GetTbScreeningListResponse Success
     * @throws ApiError
     */
    public static getTbScreeningListEndpoint(
        pageNumber: number,
        pageSize: number,
    ): CancelablePromise<GetTbScreeningListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/screening/tb/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get paginated list of investigation tests for patient.
     * Get paginated list of investigation tests for patient.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param code
     * @param sortBy
     * @param sortDirection
     * @param typeId
     * @param status
     * @param testedAtFrom
     * @param testedAtTo
     * @returns InvestigationTestsListDto The paginated list of investigation tests for patient.
     * @throws ApiError
     */
    public static getPatientInvestigationTestsEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        code?: string | null,
        sortBy?: InvestigationTestSortBy | null,
        sortDirection?: ListSortDirection | null,
        typeId?: string | null,
        status?: InvestigationTestStatus | null,
        testedAtFrom?: string | null,
        testedAtTo?: string | null,
    ): CancelablePromise<InvestigationTestsListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/patient/tests',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'code': code,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'typeId': typeId,
                'status': status,
                'testedAtFrom': testedAtFrom,
                'testedAtTo': testedAtTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Update investigation demand.
     * Update investigation demand.
     * @param id The unique identifier of the investigation demand to be updated.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateInvestigationDemandEndpoint(
        id: string,
        requestBody: UpdateInvestigationDemandRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation demand has not been found.`,
            },
        });
    }
    /**
     * Get investigation demand information.
     * Get investigation demand information.
     * @param id The unique identifier of the investigation demand.
     * @returns InvestigationDemandEnrichedDto The investigation demand.
     * @throws ApiError
     */
    public static getInvestigationDemandEndpoint(
        id: string,
    ): CancelablePromise<InvestigationDemandEnrichedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The investigation demand has not been found.`,
            },
        });
    }
    /**
     * Get paginated list of investigation demands.
     * Get paginated list of investigation demands.
     * @param pageNumber The page number for the requested data. The default value is 1.
     * @param pageSize The number of records per page. The default value is 10.
     * @param searchTerm This property is used to filter items
     * containing strings matching the specified value.
     * @param sortBy Specifies the property by which the investigation demands should be sorted.
     * If null, no particular sorting is applied.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the investigation demands.
     * If null, the default sorting direction is applied.
     * @param investigationDemandIds An array of Investigation Demand IDs to filter the results.
     * Use this property to retrieve investigation demands matching the specified identifiers.
     * @param code The unique identifier associated with the investigation demand.
     * Use this property to retrieve investigation demands matching the specified QR code.
     * @param personId Gets or sets the identifier of the person under investigation.
     * Use this to filter investigation demands associated with a specific person.
     * @param personIds Gets or sets the identifiers of the person under investigation.
     * Use this to filter investigation demands associated with a specific persons.
     * @param institutionId Gets or sets the identifier of the institution associated with the investigation demands.
     * Use this to filter investigation demands based on a specific institution.
     * @param institutionUserId This property represents the unique identifier of a user associated with an institution,
     * used to filter investigation demands for queries involving specific institution users.
     * @param status Gets or sets the status of the investigation demand.
     * This property is used to filter investigation demands based on their current status.
     * @param createdAtFrom Gets or sets the minimum date and time for filtering
     * investigation demands based on their creation date.
     * This property is used to retrieve investigation demands
     * that were created on or after the specified date and time.
     * @param createdAtTo Gets or sets the upper boundary for the creation date of the investigation demands to be retrieved.
     * Use this to filter demands created on or before a specific date.
     * @param isPregnancyMonitoring Indicates whether to filter investigation demands specifically for pregnancy monitoring.
     * If set to true, only investigation demands related to pregnancy monitoring will be returned.
     * If set to false, investigation demands not related to pregnancy monitoring will be returned.
     * If null, this filter is not applied.
     * @param isNewborn Indicates whether the investigation demand is related to a newborn individual.
     * Optional property that may be used to filter investigation demands specific to newborns.
     * @param isAnonymous Indicates whether to filter investigation demands specifically for anonymous.
     * If set to true, only investigation demands related to anonymous persons will be returned.
     * If set to false, investigation demands not related to anonymous persons will be returned.
     * If null, this filter is not applied.
     * @returns InvestigationDemandListDto The paginated list of investigation demands.
     * @throws ApiError
     */
    public static getInvestigationDemandListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        sortBy?: InvestigationDemandSortBy | null,
        sortDirection?: ListSortDirection | null,
        investigationDemandIds?: Array<string> | null,
        code?: string | null,
        personId?: string | null,
        personIds?: Array<string> | null,
        institutionId?: string | null,
        institutionUserId?: string | null,
        status?: InvestigationDemandStatus | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        isPregnancyMonitoring?: boolean | null,
        isNewborn?: boolean | null,
        isAnonymous?: boolean | null,
    ): CancelablePromise<InvestigationDemandListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/investigation-demands/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'investigationDemandIds': investigationDemandIds,
                'code': code,
                'personId': personId,
                'personIds': personIds,
                'institutionId': institutionId,
                'institutionUserId': institutionUserId,
                'status': status,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'isPregnancyMonitoring': isPregnancyMonitoring,
                'isNewborn': isNewborn,
                'isAnonymous': isAnonymous,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Create investigation demand.
     * Create investigation demand.
     * @param requestBody
     * @returns CreateInvestigationDemandResponse The investigation demand.
     * @throws ApiError
     */
    public static createInvestigationDemandEndpoint(
        requestBody: CreateInvestigationDemandRequest,
    ): CancelablePromise<CreateInvestigationDemandResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Create screening investigation in single operation.
     * Creates a complete screening investigation with demand, one specimen and, for every item, a specimen investigation, test and result, in a single atomic transaction. No laboratory approval workflow required.
     * @param requestBody
     * @returns CreateScreeningInvestigationResponse Screening investigation created successfully with all entities.
     * @throws ApiError
     */
    public static createScreeningInvestigationEndpoint(
        requestBody: CreateScreeningInvestigationRequest,
    ): CancelablePromise<CreateScreeningInvestigationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/investigation-demands/screening',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation errors occurred.`,
                401: `User is not authorized.`,
                404: `Referenced entity not found.`,
                409: `Conflict with existing data or invalid type combinations.`,
                500: `Internal server error occurred.`,
            },
        });
    }
    /**
     * Cancel investigation demand.
     * Cancel investigation demand based on the provided identifier.
     * @param id The identifier of the investigation demand.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static cancelInvestigationDemandEndpoint(
        id: string,
        requestBody: CancelInvestigationDemandRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/investigation-demands/{id}/cancellation',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Investigation demand does not exists or already canceled.`,
            },
        });
    }
}
